import { connect } from 'react-redux';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { withActiveWindowLoader } from '../../../../../core';
import { cancelOrderItems as cancelOrderItemsAction } from '../../../ducks/orderItems';

interface DispatchProps {
    cancelOrderItems: (orderItemIds: string[]) => void;
}

interface OwnProps {
    refetchGroup: () => void;
}

export default connect<null, DispatchProps, OwnProps>(null, (dispatch: CommanderThunkDispatch, { refetchGroup }) => ({
    cancelOrderItems: async (orderItemIds: string[]) =>
        withActiveWindowLoader(async () => dispatch(cancelOrderItemsAction(orderItemIds))).then(refetchGroup),
}));
